import { type ReactNode, useMemo } from 'react';
import { LearningSessionContext } from '@/providers/learning-session-context';
import {
  useLearningSessionTracker,
  useLearningSessionTrackerEnabled,
} from '@/hooks/useLearningSessionTracker';

export function LearningSessionProvider({ children }: { children: ReactNode }) {
  const enabled = useLearningSessionTrackerEnabled();
  const { markActivity, setMediaPlaying, setActivityEngaged, config, liveStatus, isTracking } =
    useLearningSessionTracker({ enabled });

  const status = useMemo(
    () => ({
      config,
      currentSessionSeconds: liveStatus.currentSessionSeconds,
      todaySeconds: liveStatus.todaySeconds,
      isTracking,
    }),
    [config, isTracking, liveStatus.currentSessionSeconds, liveStatus.todaySeconds],
  );

  const value = useMemo(
    () => ({ setMediaPlaying, setActivityEngaged, markActivity, status }),
    [setMediaPlaying, setActivityEngaged, markActivity, status],
  );

  return <LearningSessionContext.Provider value={value}>{children}</LearningSessionContext.Provider>;
}
